import React from 'react';
import SingleImageUploader from '../../../components/form/SingleImageUploader';
import TenantMedia from './TenantMedia';
import { Controller } from 'react-hook-form';
const Media = ({ isEditable, loading, form }) => {
  const convertToEmbedUrl = (youtubeUrl) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?v=|embed\/|v\/|video\/|.+\?v=)?([^"&?\/\s]{11})/;
    const match = youtubeUrl.match(regex);

    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    } else {
      throw new Error('Invalid YouTube URL');
    }
  };

  const handleMediaChange = (val, type, index, currentValue, is_primary, callback) => {
    const media = [...currentValue];
    const newMedia = {
      url: type === 'YOUTUBE_URL' ? convertToEmbedUrl(val) : val,
      is_primary,
      type
    };
    media[index] = newMedia;
    callback(media);
  };

  return (
    <div className="tabs__content pt-30 js-tabs-content">
      <div className="tabs__pane -tab-item-1 is-tab-el-active">
        <Controller
          control={form.control}
          name="media"
          render={({ field: { onChange, value } }) => (
            <div className="row">
              <div className="col-12">
                <SingleImageUploader
                  id="primaryImage"
                  required={true}
                  label="Gambar Utama"
                  disabled={loading || !isEditable}
                  description="Rekomendasi ukuran gambar yang disarankan adalah 1280x720px"
                  onChange={(val) => handleMediaChange(val, 'IMAGE', 0, value, true, onChange)}
                  path="tenant/profile/"
                  accept="image/*"
                  isError={Boolean(
                    form.formState.errors.media && form.formState.errors.media[0].url
                  )}
                  errorMessage={
                    Boolean(form.formState.errors.media && form.formState.errors.media[0].url) &&
                    form.formState.errors.media &&
                    form.formState.errors.media[0].url.message
                  }
                  value={value[0].url}
                />
              </div>
              <div className="col-12">
                <label className="fw-500 mb-10">Media Tambahan</label>
              </div>
              <div className="col-3">
                <TenantMedia
                  isEditable={isEditable}
                  loading={loading}
                  value={value[1].url}
                  type={value[1].type}
                  handleMediaChange={(val, index, type) =>
                    handleMediaChange(val, type, index, value, false, onChange)
                  }
                  index={1}
                />
              </div>
              <div className="col-3">
                <TenantMedia
                  isEditable={isEditable}
                  loading={loading}
                  value={value[2].url}
                  type={value[2].type}
                  handleMediaChange={(val, index, type) =>
                    handleMediaChange(val, type, index, value, false, onChange)
                  }
                  index={2}
                />
              </div>
              <div className="col-3">
                <TenantMedia
                  isEditable={isEditable}
                  loading={loading}
                  value={value[3].url}
                  type={value[3].type}
                  handleMediaChange={(val, index, type) =>
                    handleMediaChange(val, type, index, value, false, onChange)
                  }
                  index={3}
                />
              </div>
              <div className="col-3">
                <TenantMedia
                  isEditable={isEditable}
                  loading={loading}
                  value={value[4].url}
                  type={value[4].type}
                  handleMediaChange={(val, index, type) =>
                    handleMediaChange(val, type, index, value, false, onChange)
                  }
                  index={4}
                />
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default Media;
